import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const withToken = async () => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

export const getSyncPageable = createAsyncThunk("syncFeeder/getSyncPageable", async({page, pageSize, search, periode, status}) => {
    await withToken();
    const searchParams = search === undefined ? "" : search;
    const periodeParams = periode === undefined ? "" : periode;
    const statusParams = status === undefined ? "" : status;
    const url = `v1/sync/pendaftar/pageable?page=${page}&size=${pageSize}&search=${searchParams}&periode=${periodeParams}&status=${statusParams}`;
    const response = await jwtAuthAxios.get(url);
    return response.data;
});

export const getSyncPeriode = createAsyncThunk("syncFeeder/getSyncPeriode", async() => {
    await withToken();
    const response = await jwtAuthAxios.get(`v1/sync/pendaftar/periode`);
    return response.data;
});

export const getSyncSteps = createAsyncThunk("syncFeeder/getSyncSteps", async(nim) => {
    await withToken();
    const response = await jwtAuthAxios.get(`v1/sync/pendaftar/${nim}/steps`);
    return response.data;
});

export const getSyncStatus = createAsyncThunk("syncFeeder/getSyncStatus", async(nims) => {
    await withToken();
    const response = await jwtAuthAxios.get(`v1/sync/pendaftar/status?nims=${nims.join(',')}`);
    return response.data;
});

export const runSync = createAsyncThunk("syncFeeder/runSync", async({nims, fromStep}) => {
    await withToken();
    const response = await jwtAuthAxios.post(`v1/sync/pendaftar/run`, {nims, fromStep});
    return response.data;
});

export const runNotSynced = createAsyncThunk("syncFeeder/runNotSynced", async(periode) => {
    await withToken();
    const response = await jwtAuthAxios.post(`v1/sync/pendaftar/run-not-synced`, {periode});
    return response.data;
});

const initialState = {
    loadingList: false,
    loadingSteps: false,
    loadingRun: false,
    responsePageable: {},
    listSteps: [],
    listPeriode: [],
    statusRows: [],
    responseRun: {},
};

const syncFeederSlice = createSlice({
    name: "syncFeederSlice",
    initialState: initialState,
    reducers: {
        clearSteps: (state) => {
            state.listSteps = [];
        },
    },
    extraReducers: {
        [getSyncPageable.pending]: (state) => {
            state.loadingList = true;
        },
        [getSyncPageable.fulfilled]: (state, action) => {
            state.responsePageable = action.payload;
            state.loadingList = false;
        },
        [getSyncPageable.rejected]: (state) => {
            state.loadingList = false;
        },
        [getSyncPeriode.fulfilled]: (state, action) => {
            state.listPeriode = action.payload?.data || [];
        },
        [getSyncSteps.pending]: (state) => {
            state.loadingSteps = true;
        },
        [getSyncSteps.fulfilled]: (state, action) => {
            state.listSteps = action.payload?.data || [];
            state.loadingSteps = false;
        },
        [getSyncSteps.rejected]: (state) => {
            state.loadingSteps = false;
        },
        [getSyncStatus.fulfilled]: (state, action) => {
            state.statusRows = action.payload?.data || [];
        },
        [runSync.pending]: (state) => {
            state.loadingRun = true;
        },
        [runSync.fulfilled]: (state, action) => {
            state.responseRun = action.payload;
            state.loadingRun = false;
        },
        [runSync.rejected]: (state) => {
            state.loadingRun = false;
        },
        [runNotSynced.pending]: (state) => {
            state.loadingRun = true;
        },
        [runNotSynced.fulfilled]: (state, action) => {
            state.responseRun = action.payload;
            state.loadingRun = false;
        },
        [runNotSynced.rejected]: (state) => {
            state.loadingRun = false;
        },
    }
});

export const { clearSteps } = syncFeederSlice.actions;
export const syncFeederSelector = (state) => state.syncFeeder;
export default syncFeederSlice.reducer;
